/* eslint-disable react/no-array-index-key */
import React, { memo, type FC } from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import { Dot, DotsStyled } from './styled';
import { type HandleDealCardCtaCallBack } from '../../types';

type DotsProps = {
  itemsLength: number;
  selectedItem: number;
  galleryContainerNode: Element | null;
  isOverlay: boolean;
  handleDealCardCtaCallBack: HandleDealCardCtaCallBack;
  fullWidthOnMobile?: boolean;
};

const Dots: FC<DotsProps> = memo(
  ({ itemsLength, selectedItem, galleryContainerNode, isOverlay, handleDealCardCtaCallBack, fullWidthOnMobile }) => {
    const { t } = useTranslation();

    if (itemsLength === 1) {
      return null;
    }

    const handleOnClick = (selItem: number) => {
      const child = galleryContainerNode?.childNodes[selItem] as HTMLDivElement;

      if (child) {
        child.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }

      handleDealCardCtaCallBack({
        payload: {
          event_name: 'gallery_dot',
          event_subcontext: 'button',
        },
      });
    };

    return (
      <DotsStyled isOverlay={isOverlay} className="dots" fullWidthOnMobile={fullWidthOnMobile}>
        {Array(itemsLength)
          .fill('')
          .map((x, i) => (
            <Dot
              key={`dot_${i}`}
              type="button"
              isSelected={i === selectedItem}
              onClick={() => handleOnClick(i)}
              aria-label={`${t('vacation.oss.cards.gallery.goto_image')} ${i + 1}`}
              aria-current={i === selectedItem}
              tabIndex={i === selectedItem ? -1 : 0}
            />
          ))}
      </DotsStyled>
    );
  },
  (prevProps: DotsProps, nextProps: DotsProps) => {
    if (prevProps.selectedItem !== nextProps.selectedItem) return false;
    if (prevProps.itemsLength !== nextProps.itemsLength) return false;
    if (prevProps.galleryContainerNode !== nextProps.galleryContainerNode) return false;
    return true;
  }
);

Dots.displayName = 'Dots';

export default Dots;
